export default {
    title: 'รวมคู่มือแยกตามกิจกรรมของ 매일국어 T',
};
